const APP_URL = 'https://app.theonestack.com/build';

const footerLinks = [
  {
    heading: 'Product',
    links: [
      { label: 'Features', href: '#features' },
      { label: 'How It Works', href: '#how-it-works' },
      { label: 'Pricing', href: '#pricing' },
      { label: 'Sub Portal', href: '#sub-portal' },
    ],
  },
  {
    heading: 'Company',
    links: [
      { label: 'The One Stack', href: 'https://theonestack.com' },
      { label: 'Privacy Policy', href: '/privacy' },
      { label: 'Terms of Service', href: '/terms' },
    ],
  },
  {
    heading: 'Support',
    links: [
      { label: 'Documentation', href: '#' },
      { label: 'Contact Us', href: '#' },
      { label: 'System Status', href: '#' },
      { label: 'Sign In', href: APP_URL },
    ],
  },
];

export function Footer() {
  return (
    <footer className="border-t border-build-700/30 bg-[#0d0d0d]">
      <div className="mx-auto max-w-6xl px-6 py-16">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {/* Brand */}
          <div>
            <div className="mb-4 flex items-center gap-2.5">
              <BuildIconSmall />
              <span className="font-semibold tracking-tight">The One Build</span>
            </div>
            <p className="text-sm text-zinc-500 leading-relaxed">
              Construction management software for the way you work. Part of The One Stack.
            </p>
          </div>

          {/* Link columns */}
          {footerLinks.map((col) => (
            <div key={col.heading}>
              <h4 className="mb-4 text-sm font-semibold text-zinc-300">{col.heading}</h4>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-zinc-500 transition hover:text-zinc-300"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-build-700/20 pt-8 sm:flex-row">
          <p className="text-xs text-zinc-600">
            &copy; 2026 The One Stack. All rights reserved.
          </p>
          <p className="text-xs text-zinc-600">
            Part of The One Stack ecosystem
          </p>
        </div>
      </div>
    </footer>
  );
}

function BuildIconSmall() {
  return (
    <svg width="22" height="22" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="6" fill="#1a1a1a" />
      <path
        d="M8 24H24M10 24V14L16 8L22 14V24"
        stroke="url(#footer-build-grad)"
        strokeWidth="1.5"
        strokeLinejoin="round"
        strokeLinecap="round"
        fill="none"
      />
      <rect x="13" y="18" width="6" height="6" rx="0.5" stroke="#f97316" strokeWidth="1.2" fill="none" />
      <path d="M16 8L16 5" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" />
      <defs>
        <linearGradient id="footer-build-grad" x1="8" y1="8" x2="24" y2="24" gradientUnits="userSpaceOnUse">
          <stop stopColor="#fb923c" />
          <stop offset="1" stopColor="#f97316" />
        </linearGradient>
      </defs>
    </svg>
  );
}
